import Stack from "@mui/material/Stack";
import { alpha, styled } from "@mui/material/styles";
import Typography from "@mui/material/Typography";
import React from "react";

import { bgGradient } from "src/utils/cssStyles";

import { Icon } from "./components/Icon";

interface AuthPageTemplateProps {
  title: string;
  icon?: {
    src: string;
    alt: string;
    width?: number;
    height?: number;
  };
  children: React.ReactNode;
}

const AuthPageTemplate = ({ title, icon, children }: AuthPageTemplateProps) => {
  return (
    <BackgroundGradient>
      <CentralCard>
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            flexDirection: "column",
            alignItems: "center",
            textAlign: "center",
          }}
        >
          <Icon icon={icon} />

          <Typography variant="h3" style={{ marginBottom: "0.5rem" }}>
            {title}
          </Typography>

          <div style={{ width: "100%" }}>{children}</div>
        </div>
      </CentralCard>
    </BackgroundGradient>
  );
};

export { AuthPageTemplate };

const BackgroundGradient = styled("div")(({ theme }) => ({
  ...bgGradient({
    color: alpha(theme.palette.background.default, 0.9),
    imgUrl: "/assets/background/overlay_1.jpg",
  }),
  display: "flex",
  minHeight: "100vh",
  alignItems: "center",
  justifyContent: "center",
  padding: theme.spacing(12, 2),
}));

const CentralCard = ({ children }: React.PropsWithChildren) => {
  return (
    <Stack
      spacing={4}
      sx={{
        p: 4,
        width: 1,
        mx: "auto",
        flexShrink: 0,
        maxWidth: 400,
        borderRadius: 2,
        bgcolor: "background.default",
        textAlign: { xs: "center", md: "left" },
        boxShadow: (theme) => theme.customShadows.z24,
      }}
    >
      {children}
    </Stack>
  );
};
